export var TabsDisplayType;
(function (TabsDisplayType) {
    TabsDisplayType["Primary"] = "Primary";
    TabsDisplayType["Secondary"] = "Secondary"; // looks more like buttons
})(TabsDisplayType || (TabsDisplayType = {}));
//# sourceMappingURL=display-type.js.map